import { render, staticRenderFns } from "./FakeTextarea.vue?vue&type=template&id=4e2f684c&scoped=true&"
import script from "./FakeTextarea.vue?vue&type=script&lang=js&"
export * from "./FakeTextarea.vue?vue&type=script&lang=js&"
import style0 from "./FakeTextarea.vue?vue&type=style&index=0&id=4e2f684c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2f684c",
  null
  
)

export default component.exports